import {
  SHOW_LOADING,
  HIDE_LOADING,
  FETCHED_TEAM_A_MAPPING,
  FETCHED_TEAM_B_MAPPING,
  CLEAR_PLAYER_MATCH_MAPPING,
  RETURN_PLAYER_MATCH_MAPPING_ERROR,
} from "./types";
import axios from "axios";
import { SSENSE_URL } from "../../config/stepoutAPI";

export const clearPlayerMatchMappings = () => {
  return { type: CLEAR_PLAYER_MATCH_MAPPING };
};

export const getUserMatchMapping = async (matchId, teamId, token) => {
  const formData = new FormData();
  formData.append("match_id", matchId);
  formData.append("team_id", teamId);

  const response = await axios({
    method: "post",
    url: `${SSENSE_URL}get_user_match_mapping/`,
    data: formData,
    headers: {
      Authorization: "ANALYST " + token,
      "Content-Type": "json",
    },
  });
  return response;
};

export const getPlayerMatchMapping = (matchId, teamAId, teamBId, token) => {
  return async (dispatch) => {
    dispatch(clearPlayerMatchMappings());
    dispatch({ type: SHOW_LOADING });
    try {
      Promise.all([
        getUserMatchMapping(matchId, teamAId, token),
        getUserMatchMapping(matchId, teamBId, token),
      ])
        .then((values) => {
          if (values.length < 2) {
            throw new Error("Response is not proper!");
          }

          if (values[0].status === 200) {
            dispatch({
              type: FETCHED_TEAM_A_MAPPING,
              payload: values[0]?.data,
            });
          } else {
            dispatch(clearPlayerMatchMappings());
            dispatch({ type: RETURN_PLAYER_MATCH_MAPPING_ERROR });
          }

          if (values[1].status === 200) {
            dispatch({
              type: FETCHED_TEAM_B_MAPPING,
              payload: values[1]?.data,
            });
          } else {
            dispatch(clearPlayerMatchMappings());
            dispatch({ type: RETURN_PLAYER_MATCH_MAPPING_ERROR });
          }
        })
        .catch((error) => {
          dispatch(clearPlayerMatchMappings());
        })
        .finally(() => dispatch({ type: HIDE_LOADING }));
    } catch (error) {
      console.log("error:", error);
      dispatch(clearPlayerMatchMappings());
    } finally {
      dispatch({ type: HIDE_LOADING });
    }
  };
};
